import { render, staticRenderFns } from "./SurveyImprovements.vue?vue&type=template&id=d304cb22&"
import script from "./SurveyImprovements.vue?vue&type=script&lang=js&"
export * from "./SurveyImprovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports